import { MonitorSmartphone } from 'lucide-react';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';

// Aviso amable para pantallas por debajo del target de la app (MVP: desktop
// + tablet ≥768px, decisión B.4 #3). Overlay puro CSS (md:hidden — el
// breakpoint "md" de Tailwind es 768px): sin JS, cubre el shell incluso si
// el user achica la ventana en vivo sin recargar.
// R4b (Ajuste 31): contenido con Empty TAL CUAL; el fondo bg-surface-page
// del overlay se queda (no es una card acotada como el resto de los vacíos
// de la app — es el aviso de pantalla completa, sin `border`).
export function MobileGuard() {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-surface-page px-6 md:hidden">
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <MonitorSmartphone aria-hidden="true" />
          </EmptyMedia>
          <EmptyTitle>RedeApp está pensada para tablet o desktop</EmptyTitle>
          <EmptyDescription>Abrí la app desde una pantalla más grande para usarla cómodamente.</EmptyDescription>
        </EmptyHeader>
      </Empty>
    </div>
  );
}
